import {
  Box,
  TextField,
  FormControl,
  InputAdornment,
  InputLabel,
  Input,
  IconButton,
  Button,
  Typography,
  Select,
  MenuItem,
  FormHelperText,
  Alert,
  Divider,
} from "@mui/material";
import {
  AccountCircleOutlined,
  Visibility,
  VisibilityOff,
  LockOutlined,
  Group,
} from "@mui/icons-material";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { set } from "lodash";
import { Tabs } from "../../../components/tabs";
import { Grid } from "../../../components/table";
import { CONFIG } from "../../../../config";
import axios from "axios";
import { ToolBar } from "../../../components/toolbar";
import { Modal } from "../../../components/modal";
import { FormA } from "../../../components/form";
import moment from "moment";
import { getFormState } from "../../../../helpers/form";
import dayjs from "dayjs";
import { SelectA, FileUploadA, DatePickerA } from "../../../components/form";
import { FollowUpList } from "../follow-up";
import { NewDataList } from "../new-data";
import { Today } from "../today";
import { LiveAllocation } from "../live-allocation";

import { AllocationUpload } from "./upload-data";
import { LinkCaseUploadPage } from "./pages/link-case-upload/link-case-upload-page";
import { ECDList } from "../ecd-reports";
const API_HOST = CONFIG.modules["accounts"].host;

const items = {
  // 'Live Shifts': {
  //     name: 'Live Shifts',
  //     view: ()=> (<LiveAllocation/>)
  // },
  // 'Todays Allocation': {
  //     name: 'Todays Allocation',
  //     view: ()=> (<Today/>)
  // },
  Upload: {
    name: "Upload",
    view: () => <AllocationUpload />,
  },
  // Link: {
  //   name: "Link",
  //   view: () => <LinkCaseUploadPage />,
  // },
  // 'New Data': {
  //     name: 'New Data',
  //     view: () => (<NewDataList />)
  // },
  // 'Follow-Up Data': {
  //     name: 'Follow-Up Data',
  //     view: () => (<FollowUpList />)
  // },
  // 'Sankalp Reports': {
  //     name: 'Sankalp Reports',
  //     view: () => <SankalpList />
  // },
  // 'ECD Reports': {
  //     name: 'ECD Reports',
  //     view: () => <ECDList />
  // },
  // 'Upload': {
  //     name: 'Upload',
  //     view: () => <AllocationUpload />
  // },
};

const markStyle = {
  borderRadius: 1,
  ml: 2,
  minWidth: 300,
  background: "#F3D55B",
  mb: 3,
  height: 40,
  pl: 2,
  display: "flex",
  alignItems: "center",
};

const wrap = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};
const text2 = { fontSize: ".8em" };
export const Uploads = (props) => {
  const {
    roles,
    user,
    users,
    Designations,
    Departments,
    Languages,
    Districts,
    Campaigns,
  } = useSelector((state) => state.user || {});
  const { state } = props.location;

  console.log(state, "props route");

  const [active, setActive] = useState("Upload");

  return (
    <>
      <Tabs
        items={items}
        active={active}
        state={state}
        onChange={(key) => {
          setActive(key);
        }}
      />
      {items[active] && items[active].view && items[active].view()}
    </>
  );
};
